module.exports = __webpack_public_path__ + "static/img/LavaPro-MedIta.7eb6102.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-MedIta.svg
// module id = hdIG
// module chunks = 0